import { loginService } from '@vip-activity/business';
export var defaultAvatar = 'https://puui.qpic.cn/vupload/0/1578879507457_tbcgkxdwgth.png/0';
export var loginTypeImg = {
  qq: 'https://puep.qpic.cn/vupload/0/20180728_1532769977168.png/0',
  wx: 'https://puui.qpic.cn/vupload/0/20180728_1532769975346.png/0'
};
export default {
  name: 'Avatar',
  props: {
    headurl: {
      type: String,
      default: defaultAvatar
    },
    vipIcon: {
      type: String,
      default: ''
    },
    nick: {
      type: String,
      default: ''
    },
    loginType: {
      type: String,
      default: ''
    },
    loginOnClick: {
      type: Boolean,
      default: false
    }
  },
  render: function render(h) {
    var _this = this;

    // eslint-disable-line no-unused-vars
    var handleAvatarClick = function handleAvatarClick() {
      if (_this.loginOnClick) {
        loginService.openLogin();
      }
    };

    return h("section", {
      "class": "avatar"
    }, [h("div", {
      "class": "avatar__inner",
      "on": {
        "click": handleAvatarClick
      }
    }, [h("img", {
      "class": "avatar__img",
      "attrs": {
        "src": this.headurl || defaultAvatar
      }
    }), this.loginType ? h("div", {
      "class": "login-type"
    }, [h("img", {
      "attrs": {
        "src": loginTypeImg[this.loginType]
      }
    })]) : '']), this.nick || this.vipIcon ? h("div", {
      "class": "avatar__cont"
    }, [this.nick ? h("h3", {
      "class": "avatar__name"
    }, [this.nick]) : '', this.vipIcon ? h("img", {
      "class": "avatar__vip",
      "attrs": {
        "src": this.vipIcon
      }
    }) : '']) : '']);
  }
};